import { render, staticRenderFns } from "./org-management-table.vue?vue&type=template&id=8fd50bc2&scoped=true&"
import script from "./org-management-table.vue?vue&type=script&lang=js&"
export * from "./org-management-table.vue?vue&type=script&lang=js&"
import style0 from "./org-management-table.vue?vue&type=style&index=0&id=8fd50bc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd50bc2",
  null
  
)

export default component.exports